export default __webpack_public_path__ + "static/media/Gray-Youtube.84a1ccb8.svg";